import { Routes } from "@angular/router";
import { CanActivateAuthGuardFn } from "./modules/shared/guards/auth.guard";

export const APP_ROUTES: Routes = [
    { path: "", redirectTo: "app", pathMatch: "full" },
    {
        path: "app",
        canActivate: [CanActivateAuthGuardFn],
        loadChildren: () =>
            import("./modules/inner/inner.routes").then((m) => m.INNER_ROUTES)
    },
    {
        path: "login",
        loadChildren: () =>
            import("./modules/login/login.routes").then((m) => m.LOGIN_ROUTES)
    },
    { path: "**", redirectTo: "app" }
];
